module.exports = __webpack_public_path__ + "img/f2fd6c9.jpg";